import React from "react";
import Wrapper from "../Wrapper";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../components/Paginator";
import Deleter from "../components/Deleter";
import { connect } from "react-redux";
import { User } from "../../classes/user";
import { toast } from "react-hot-toast";
import { Review } from "../../classes/review";

const Reviews = (props: { user: User }) => {
  const [reviews, setReviews] = React.useState([]);
  const [lastPage, setLastPage] = React.useState(0);
  const page = 1;

  React.useEffect(() => {
    (async () => {
      // const response = await axios.get(`reviews?page=${page}`);

      // setReviews(response.data.data);
      // setLastPage(response.data.meta.last_page);

      await axios
        .get(`reviews?page=${page}`)
        .then((response) => {
          setReviews(response.data.data);
          setLastPage(response.data.meta.last_page);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.error);
        });
    })();
  }, []);

  const handleDelete = async (id: number) => {
    setReviews(reviews.filter((p: Review) => p.id !== id));
  };

  const handlePageChange = async (page: number) => {
    const response = await axios.get(`reviews?page=${page}`);

    setReviews(response.data.data);
  };

  const actions = (id: number) => {
    if (props.user.canEdit("reviews")) {
      return (
        <div className="btn-group mr-2">
          <Link
            to={`/reviews/${id}/edit`}
            className="btn btn-sm btn-outline-secondary"
          >
            Edit
          </Link>
          <Deleter id={id} endpoint={"reviews"} handleDelete={handleDelete} />
        </div>
      );
    }
  };

  let addButton = null;

  if (props.user.canEdit("reviews")) {
    addButton = (
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <div className="btn-toolbar mb-2 mb-md-0">
          <Link
            to={"/reviews/create"}
            className="btn btn-sm btn-outline-secondary"
          >
            Add
          </Link>
        </div>
      </div>
    );
  }

  const getImage = (image: string) => {
    if (String(image).includes("http")) {
      return image;
    } else {
      return process.env.REACT_APP_BACKEND_URL + "/" + image;
    }
  };

  return (
    <Wrapper>
      {addButton}

      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Avatar</th>
              <th>Name</th>
              <th>Score</th>
              <th>Content</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review: Review) => {
              return (
                <tr key={review.id}>
                  <td>{review.id}</td>
                  <td>
                    <img src={getImage(review.avatar)} alt="" width="50" />
                  </td>
                  <td>{review.name}</td>
                  <td>{review.score}</td>
                  <td>{review.content}</td>
                  <td>{actions(review.id)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Paginator lastPage={lastPage} handlePageChange={handlePageChange} />
    </Wrapper>
  );
};

// @ts-ignore
export default connect((state) => ({ user: state.user }))(Reviews);
